import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../ui/Card';
import Button from '../ui/Button';
import SaleFormContent from './SaleFormContent';
import { useSaleForm } from './hooks/useSaleForm';

interface Props {
  onSuccess: () => void;
}

const AddSaleForm: React.FC<Props> = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [showVendorModal, setShowVendorModal] = useState(false);
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    isValid,
    isSubmitting,
    submitError
  } = useSaleForm(onSuccess);

  return (
    <Card>
      <form onSubmit={handleSubmit} className="space-y-6">
        {submitError && (
          <div className="text-red-600 text-sm">{submitError}</div>
        )}

        <SaleFormContent 
          values={values}
          errors={errors}
          onChange={handleChange}
          showVendorModal={showVendorModal}
          setShowVendorModal={setShowVendorModal}
          disabled={isSubmitting}
        />

        <div className="flex justify-end space-x-3">
          <Button
            type="button"
            variant="secondary"
            onClick={onSuccess}
            disabled={isSubmitting}
          >
            {t('common.cancel')}
          </Button>
          <Button
            type="submit"
            disabled={!isValid || isSubmitting}
          >
            {isSubmitting ? t('common.loading') : t('sales.addSale')}
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default AddSaleForm;